(() => {
  const sourceUrl = document.currentScript?.dataset.source;
  const storageKey = 'floral-delivery-postcode-v2';
  const manualMode = false;
  const served = (code) => /^\d{5}$/.test(code) && /^(54100|5405\d|5420\d|54290|5458\d|5460\d)$/.test(code);
  const manualDistrict = (code) => {
    if (/^(54100|54290)$/.test(code)) return 'Adapazarı';
    if (/^5405\d$/.test(code)) return 'Serdivan';
    if (/^5420\d$/.test(code)) return 'Erenler';
    if (/^5458\d$/.test(code)) return 'Arifiye';
    if (/^5460\d$/.test(code)) return 'Sapanca';
    return '';
  };
  const emptyPreference = () => ({ district: '', neighborhood: '', manual: manualMode, code: '' });
  let preference = emptyPreference();
  let storageAvailable = false;
  let lastHandoff = null;
  let data;
  let busy = false;
  let navigating = false;
  let bypassForm;
  const pending = new Set();
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    const legacy = saved.preference ? saved : JSON.parse(sessionStorage.getItem('floral-delivery-postcode-v1') || '{}');
    if (saved.lastHandoff) lastHandoff = saved.lastHandoff;
    if (legacy.preference) {
      if (!manualMode && legacy.preference.manual) {
        preference = emptyPreference();
        lastHandoff = null;
      } else {
        preference = { ...legacy.preference, manual: manualMode, code: manualMode ? legacy.preference.code : '' };
      }
    }
    sessionStorage.setItem(storageKey, JSON.stringify({ preference, lastHandoff }));
    storageAvailable = true;
  } catch {}
  const persist = () => {
    preference.manual = manualMode;
    if (!manualMode) preference.code = '';
    if (!storageAvailable) return false;
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ preference, lastHandoff }));
      return true;
    } catch {
      storageAvailable = false;
      return false;
    }
  };
  const track = (request) => {
    const finished = Promise.resolve(request).catch(() => {}).finally(() => pending.delete(finished));
    pending.add(finished);
    return request;
  };
  window.floralCartActivity = {
    track,
    begin() {
      let finish;
      track(new Promise((resolve) => { finish = resolve; }));
      return finish;
    },
  };
  const locked = new Map();
  const lockScopes = () => {
    for (const scope of document.querySelectorAll('#cart, #CartDrawer, #main-cart-footer, [data-cart-line-options-dialog]')) {
      if (!locked.has(scope)) locked.set(scope, { inert: scope.inert, busy: scope.getAttribute('aria-busy') });
      scope.inert = true;
      scope.setAttribute('aria-busy', 'true');
    }
  };
  const unlock = () => {
    for (const [scope, previous] of locked) {
      scope.inert = previous.inert;
      if (previous.busy === null) scope.removeAttribute('aria-busy');
      else scope.setAttribute('aria-busy', previous.busy);
    }
    locked.clear();
  };
  const setStatus = (root, message) => {
    const status = root.querySelector('[data-delivery-status]');
    status.textContent = message;
    status.hidden = !message;
  };
  const unavailable = (retry = false) => {
    for (const root of widgets()) {
      setStatus(root, retry ? window.cartStrings?.error || root.dataset.unavailable : root.dataset.unavailable);
      root.querySelector('[data-delivery-details]').open = true;
    }
  };
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, options) => {
    let mutation = false;
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      const method = (options?.method || input?.method || 'GET').toUpperCase();
      mutation = url.origin === location.origin && method === 'POST' && /\/cart\/(change|update|add|clear)(\.js)?$/.test(url.pathname);
    } catch {}
    const request = originalFetch(input, options);
    if (mutation) {
      const finished = request.then((response) => response.clone().arrayBuffer()).catch(() => {}).finally(() => pending.delete(finished));
      pending.add(finished);
    }
    return request;
  };
  const selected = () => {
    if (manualMode && preference.manual) {
      const code = String(preference.code || '');
      return served(code) ? { code, city: manualDistrict(code) } : null;
    }
    const district = data?.districts.find((entry) => entry.district === preference.district);
    const code = district && Object.keys(district.byPostcode).find((zip) => district.byPostcode[zip].includes(preference.neighborhood));
    return served(code || '') ? { code, city: district.label } : null;
  };
  const option = (value, label) => new Option(label, value);
  const widgets = () => [...document.querySelectorAll('[data-delivery-postcode]')];
  const render = () => {
    for (const root of widgets()) {
      root.hidden = !data;
      if (!data) continue;
      const district = root.querySelector('[data-delivery-district]');
      const neighborhood = root.querySelector('[data-delivery-neighborhood]');
      if (!root.dataset.initialized) {
        data.districts.forEach((entry) => district.add(option(entry.district, entry.label)));
        root.dataset.initialized = 'true';
      }
      district.value = preference.district;
      const entry = data.districts.find((item) => item.district === preference.district);
      const placeholder = neighborhood.options[0].text;
      neighborhood.replaceChildren(option('', placeholder));
      if (entry) Object.entries(entry.byPostcode).filter(([code]) => served(code)).flatMap(([, names]) => names).sort((a, b) => a.localeCompare(b, 'tr')).forEach((name) => neighborhood.add(option(name, name)));
      neighborhood.disabled = !entry;
      neighborhood.value = preference.neighborhood;
      root.querySelector('[data-delivery-manual]').checked = manualMode && preference.manual;
      root.querySelector('[data-delivery-code]').value = preference.code;
      root.querySelector('[data-delivery-neighborhood-group]').hidden = manualMode && preference.manual;
      root.querySelector('[data-delivery-code-group]').hidden = !manualMode || !preference.manual;
      district.closest('.ds-r-cart-delivery-postcode__field-group').hidden = manualMode && preference.manual;
      const locality = selected();
      let status = '';
      if (!storageAvailable) status = root.dataset.unavailable;
      else if (locality) status = '';
      else if (manualMode && preference.manual && preference.code) status = /^\d{5}$/.test(preference.code) ? root.dataset.unsupported : root.dataset.invalid;
      else if (preference.neighborhood) status = root.dataset.unsupported;
      setStatus(root, status);
      if (locality) root.querySelector('[data-delivery-prompt]').hidden = true;
    }
  };
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const settle = async () => {
    await delay((typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300) + 50);
    const deadline = Date.now() + 4000;
    do {
      while (pending.size) {
        if (Date.now() >= deadline) return false;
        await Promise.race([Promise.all([...pending]), delay(50)]);
      }
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    } while (pending.size);
    return true;
  };
  const liveControls = (formId, buttonId) => ({ form: document.getElementById(formId), button: document.getElementById(buttonId) });
  const native = (formId, buttonId) => {
    const { form, button } = liveControls(formId, buttonId);
    if (!form || !button || button.disabled) return false;
    bypassForm = form;
    try { form.requestSubmit(button); } finally { bypassForm = undefined; }
    return true;
  };
  const continueNatively = async (formId, buttonId) => {
    if (busy) return;
    busy = true;
    lockScopes();
    try {
      if (!await settle()) { unavailable(true); return; }
      unlock();
      native(formId, buttonId);
    } finally { busy = false; unlock(); }
  };
  document.addEventListener('change', (event) => {
    const root = event.target.closest('[data-delivery-postcode]');
    if (!root || busy) return;
    if (event.target.matches('[data-delivery-district]')) {
      preference.district = event.target.value;
      preference.neighborhood = '';
    } else if (event.target.matches('[data-delivery-neighborhood]')) preference.neighborhood = event.target.value;
    else if (event.target.matches('[data-delivery-manual]')) {
      if (!manualMode) return;
      preference.manual = event.target.checked;
    } else if (event.target.matches('[data-delivery-code]')) {
      if (!manualMode) return;
      preference.code = event.target.value.trim();
    }
    persist();
    render();
  });
  document.addEventListener('input', (event) => {
    if (!manualMode || busy || !event.target.matches('[data-delivery-code]')) return;
    preference.code = event.target.value.trim();
    persist();
    for (const root of widgets()) {
      if (root.contains(event.target)) continue;
      root.querySelector('[data-delivery-code]').value = preference.code;
    }
    const locality = selected();
    for (const root of widgets()) {
      setStatus(root, !storageAvailable ? root.dataset.unavailable : locality ? '' : preference.code ? (/^\d{5}$/.test(preference.code) ? root.dataset.unsupported : root.dataset.invalid) : '');
      if (locality) root.querySelector('[data-delivery-prompt]').hidden = true;
    }
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-delivery-continue]');
    if (!button) return;
    const checkout = button.closest('[data-delivery-postcode]').closest('#main-cart-footer, #CartDrawer').querySelector('[name="checkout"]');
    if (checkout?.form && !checkout.disabled && !busy) await continueNatively(checkout.form.id, checkout.id);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!['cart', 'CartDrawer-Form'].includes(form.id) || button?.name !== 'checkout' || bypassForm === form) return;
    if (busy) { event.preventDefault(); return; }
    if (button.disabled) return;
    let locality = selected();
    const root = document.querySelector(form.id === 'cart' ? '#main-cart-footer [data-delivery-postcode]' : '#CartDrawer [data-delivery-postcode]');
    if (data && storageAvailable && !locality) {
      event.preventDefault();
      if (root) {
        root.querySelector('[data-delivery-prompt]').hidden = false;
        root.querySelector('[data-delivery-details]').open = true;
        root.querySelector(manualMode && preference.manual ? '[data-delivery-code]' : '[data-delivery-district]').focus();
      } else await continueNatively(form.id, button.id);
      return;
    }
    event.preventDefault();
    busy = true;
    lockScopes();
    const formId = form.id;
    const buttonId = button.id;
    const fallback = async () => {
      if (!await settle()) { unavailable(true); return; }
      unlock();
      native(formId, buttonId);
    };
    try {
      if (!await settle()) { unavailable(true); return; }
      if (!data || !storageAvailable) { await fallback(); return; }
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);
      let cart;
      try {
        const response = await originalFetch(`${routes.cart_url}.js`, { signal: controller.signal });
        if (!response.ok) throw new Error('cart-read');
        cart = await response.json();
      } finally { clearTimeout(timeout); }
      if (!await settle()) { unavailable(true); return; }
      if (!cart.token || !cart.items?.length) { await fallback(); return; }
      locality = selected();
      if (!locality) { await fallback(); return; }
      const identity = `${locality.city}|${locality.code}`;
      if (lastHandoff?.cart === cart.token && lastHandoff.locality === identity) { await fallback(); return; }
      const controls = liveControls(formId, buttonId);
      if (!controls.form || !controls.button || controls.button.disabled) return;
      if (!controls.form.checkValidity()) { unlock(); controls.form.reportValidity(); return; }
      const current = new FormData(controls.form);
      const payload = new FormData();
      const quantities = current.getAll('updates[]');
      if (quantities.length !== cart.items.length || quantities.some((value) => !/^\d+$/.test(String(value)))) { await fallback(); return; }
      for (const quantity of quantities) payload.append('updates[]', quantity);
      if (current.has('note')) payload.append('note', current.get('note'));
      const persistence = originalFetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', headers: { Accept: 'application/json' }, body: payload,
      }).then(async (response) => {
        if (!response.ok) throw new Error('cart-update');
        const updated = await response.json();
        if (!updated.items?.length || updated.status) throw new Error('cart-update');
        return updated;
      });
      track(persistence);
      let timer;
      const expired = Symbol();
      const updated = await Promise.race([persistence, new Promise((resolve) => { timer = setTimeout(() => resolve(expired), 4000); })]).finally(() => clearTimeout(timer));
      if (updated === expired) {
        unavailable(true);
        await persistence.catch(() => {});
        return;
      }
      if (!await settle()) { unavailable(true); return; }
      const finalControls = liveControls(formId, buttonId);
      if (!finalControls.form || !finalControls.button || finalControls.button.disabled) return;
      if (!finalControls.form.checkValidity()) { unlock(); finalControls.form.reportValidity(); return; }
      const destination = new URL(`${window.Shopify?.routes?.root || '/'}checkout`, location.origin);
      destination.searchParams.set('checkout[shipping_address][country]', 'TR');
      destination.searchParams.set('checkout[shipping_address][city]', locality.city);
      destination.searchParams.set('checkout[shipping_address][zip]', locality.code);
      const previousHandoff = lastHandoff;
      lastHandoff = { cart: updated.token || cart.token, locality: identity };
      if (!persist()) { lastHandoff = previousHandoff; unavailable(); await fallback(); return; }
      try { location.assign(destination.href); navigating = true; }
      catch { lastHandoff = previousHandoff; persist(); throw new Error('checkout-navigation'); }
    } catch {
      unavailable();
      await fallback();
    } finally {
      if (!navigating) { busy = false; unlock(); }
    }
  });
  window.addEventListener('pageshow', () => { navigating = false; busy = false; unlock(); render(); });
  let loading;
  const loadData = () => {
    if (data || loading) return;
    const source = widgets()[0]?.dataset.source || sourceUrl || document.querySelector('script[data-source][src*="cart-delivery-postcode"]')?.dataset.source;
    if (!source) return;
    loading = originalFetch(source).then((response) => {
      if (!response.ok) throw new Error('postcode-data');
      return response.json();
    }).then((result) => {
      if (result.schemaVersion !== 1 || !Array.isArray(result.districts) || !result.districts.every((entry) => typeof entry.district === 'string' && typeof entry.label === 'string' && entry.byPostcode && Object.entries(entry.byPostcode).every(([code, names]) => /^\d{5}$/.test(code) && Array.isArray(names) && names.every((name) => typeof name === 'string')))) throw new Error('postcode-schema');
      data = result;
      render();
    }).catch(() => {}).finally(() => { loading = undefined; });
  };
  const observer = new MutationObserver((records) => {
    if (busy) lockScopes();
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches('[data-delivery-postcode]') || node.querySelector('[data-delivery-postcode]'))))) {
      if (data) render();
      else loadData();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  loadData();
})();
